import { Trash2 } from "lucide-react";

type QuotationDrawerFooterProps = {
  mode: "create" | "edit";
  confirmDelete: boolean;
  isPending: boolean;
  canSubmit: boolean;
  canDelete?: boolean;
  onRequestDelete: () => void;
  onConfirmDelete: () => void;
  onSubmit: () => void;
  onClose: () => void;
};

export function QuotationDrawerFooter({
  mode,
  confirmDelete,
  isPending,
  canSubmit,
  canDelete = true,
  onRequestDelete,
  onConfirmDelete,
  onSubmit,
  onClose,
}: QuotationDrawerFooterProps) {
  return (
    <footer>
      {canDelete && mode === "edit" && !confirmDelete ? (
        <button
          className="btn-danger"
          type="button"
          onClick={onRequestDelete}
          disabled={isPending}
        >
          <Trash2 size={16} aria-hidden="true" /> Excluir
        </button>
      ) : null}
      {canDelete && mode === "edit" && confirmDelete ? (
        <button
          className="btn-danger"
          type="button"
          onClick={onConfirmDelete}
          disabled={isPending}
        >
          <Trash2 size={16} aria-hidden="true" /> Confirmar exclusão
        </button>
      ) : null}
      <button type="button" onClick={onClose} disabled={isPending}>
        Cancelar
      </button>
      <button
        className="primary"
        type="button"
        onClick={onSubmit}
        disabled={isPending || !canSubmit}
      >
        {mode === "create" ? "Adicionar" : "Salvar"}
      </button>
    </footer>
  );
}
